export default __webpack_public_path__ + "vladt.4c115927.jpg";